import { NotificationsService } from './notifications.service';

/**
 * App initializer that activates the NotificationsService polling on app startup
 * This ensures notifications start polling immediately when the app loads
 *
 * Usage in app.config.ts:
 * ```typescript
 * {
 *   provide: APP_INITIALIZER,
 *   useFactory: notificationsAppInitializer,
 *   deps: [NotificationsService],
 *   multi: true,
 * }
 * ```
 */
export function notificationsAppInitializer(
  notificationsService: NotificationsService
): () => void {
  return () => {
    // Simply injecting the service activates the polling via its constructor
    // The polling subscription is managed by takeUntilDestroyed
  };
}
